/** Localized label maps for status keys used by dashboard charts. */

export const transactionStatusLabels = (isRTL: boolean): Record<string, string> => ({
  draft: isRTL ? 'مسودة' : 'Draft',
  submitted: isRTL ? 'مُرسل' : 'Submitted',
  under_review: isRTL ? 'قيد المراجعة' : 'Under Review',
  approved: isRTL ? 'معتمد' : 'Approved',
  in_progress: isRTL ? 'قيد التنفيذ' : 'In Progress',
  pending: isRTL ? 'معلق' : 'Pending',
  completed: isRTL ? 'مكتمل' : 'Completed',
  cancelled: isRTL ? 'ملغي' : 'Cancelled',
  on_hold: isRTL ? 'مُعلق مؤقتاً' : 'On Hold',
});

export const projectStatusLabels = (isRTL: boolean): Record<string, string> => ({
  draft: isRTL ? 'مسودة' : 'Draft',
  active: isRTL ? 'نشط' : 'Active',
  in_progress: isRTL ? 'قيد التنفيذ' : 'In Progress',
  on_hold: isRTL ? 'مُعلق مؤقتاً' : 'On Hold',
  completed: isRTL ? 'مكتمل' : 'Completed',
  cancelled: isRTL ? 'ملغي' : 'Cancelled',
});

export const proposalStatusLabels = (isRTL: boolean): Record<string, string> => ({
  draft: isRTL ? 'مسودة' : 'Draft',
  pending_review: isRTL ? 'قيد المراجعة' : 'Pending Review',
  approved: isRTL ? 'معتمد' : 'Approved',
  sent: isRTL ? 'مُرسل' : 'Sent',
  accepted: isRTL ? 'مقبول' : 'Accepted',
  rejected: isRTL ? 'مرفوض' : 'Rejected',
  expired: isRTL ? 'منتهي' : 'Expired',
  archived: isRTL ? 'مؤرشف' : 'Archived',
});

export const paymentStatusLabels = (isRTL: boolean): Record<string, string> => ({
  pending: isRTL ? 'معلق' : 'Pending',
  initiated: isRTL ? 'مُبتدأ' : 'Initiated',
  captured: isRTL ? 'محصّل' : 'Captured',
  failed: isRTL ? 'فشل' : 'Failed',
  refunded: isRTL ? 'مسترد' : 'Refunded',
  cancelled: isRTL ? 'ملغي' : 'Cancelled',
});

export const documentStatusLabels = (isRTL: boolean): Record<string, string> => ({
  draft: isRTL ? 'مسودة' : 'Draft',
  in_progress: isRTL ? 'قيد الإعداد' : 'In Progress',
  under_review: isRTL ? 'قيد المراجعة' : 'Under Review',
  approved: isRTL ? 'معتمد' : 'Approved',
  sent_to_client: isRTL ? 'مُرسل للعميل' : 'Sent to Client',
  signed: isRTL ? 'موقّع' : 'Signed',
  archived: isRTL ? 'مؤرشف' : 'Archived',
});

/**
 * SAR money formatting for dashboard KPIs. Latin digits in both languages —
 * 'ar-SA' rendered Arabic-Indic digits next to Latin counts on the same card.
 */
export const formatMoney = (value: number | string, _isRTL?: boolean): string => {
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (!isFinite(n)) return '0';
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
};
